export const noSpecialCharactersRegex = '^[a-zA-Z0-9]*$';
